export const MODIFY_INTEGRATION_AUTH = 'MODIFY_INTEGRATION_AUTH';

export function modifyIntegrationAuth(integrationAuth){
    return{
        type: MODIFY_INTEGRATION_AUTH,
        mainState: {
            integrationAuth: integrationAuth
        }
    }
}